import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  let mapIllu = document.querySelector('.illu--map');

  if (mapIllu) {
    let mapLandMark1 = mapIllu.querySelector('#pin-1')
    let mapLandMark2 = mapIllu.querySelector('#pin-2')
    let mapLandMark3 = mapIllu.querySelector('#pin-3')
    let landMarkTrigger = document.querySelectorAll('[data-hook=landmark-trigger]')

    let mapIlluTimeline = gsap.timeline();

    mapIlluTimeline.add('map-animation-start-0');
    mapIlluTimeline.set(mapLandMark1, { scale: 0, transformOrigin: 'bottom center' });
    mapIlluTimeline.set(mapLandMark2, { scale: 0, transformOrigin: 'bottom center' });
    mapIlluTimeline.set(mapLandMark3, { scale: 0, transformOrigin: 'bottom center' });
    mapIlluTimeline.add('map-animation-end-0');
    mapIlluTimeline.seek('map-animation-end-0');
    mapIlluTimeline.pause();

    landMarkTrigger.forEach((trigger, index) => {

      let mapPin = mapIllu.querySelector(`#pin-${index+1}`);

      mapIlluTimeline.add(
        `map-animation-start-${index+1}`
      ).to(
        mapPin, {
          scale: 1.5,
          transformOrigin: 'bottom center',
          duration: .25,
          ease: 'power2.out'
        }
      ).to(
        mapPin, {
          scale: 1,
          transformOrigin: 'bottom center',
          duration: .15,
          ease: 'power2.inout'
        }
      ).add(
        `map-animation-end-${index+1}`
      ).to(
        mapPin, {
          scale: 0,
          transformOrigin: 'bottom center',
          duration: .15,
          ease: 'power2.inout'
        }
      )

      ScrollTrigger.create({
        trigger: mapIllu,
        start: 'top 50%',
        onEnter: () => {
          mapIllu.classList.add('illu--active')
        }
      })

      ScrollTrigger.create({
        trigger: trigger,
        start: 'top center+=100px',
        onLeaveBack: () => {
          mapIlluTimeline.tweenTo(`map-animation-end-${index}`)
        },
        onEnter: () => {
          mapIlluTimeline.tweenTo(`map-animation-end-${index+1}`)
        }
      })
    })
  }
});

